var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex rounded-lg overflow-hidden",style:({ borderStyle: 'solid', borderWidth: '1px', borderColor: _vm.primaryColor, width: 'fit-content' })},_vm._l((_vm.options),function(option,index){return _c('label',{key:index,staticClass:"relative cursor-pointer mb-0"},[_c('input',{staticClass:"sr-only",attrs:{"type":"radio","name":_vm.name},domProps:{"value":option.value,"checked":_vm.modelValue === option.value},on:{"change":_vm.handleChange}}),_c('div',{class:[
        ' h-full py-2 font-medium text-sm uppercase',
        'transition-all duration-200 ease-in-out',
        'hover:opacity-80',
        {
          'border-l-2': index > 0,
          'bg-white hover:bg-gray-50': _vm.modelValue !== option.value,
        } ],style:({
        backgroundColor: _vm.modelValue === option.value ? _vm.primaryColor : 'white',
        color: _vm.modelValue !== option.value ? _vm.primaryColor : 'white',
        borderLeftColor: index > 0 ? _vm.primaryColor : 'transparent',
        width: '100px',
        display: 'flex',
        justifyContent: 'center',
      })},[_vm._v(" "+_vm._s(option.text)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }